<div class="fm-cdx-table" *ngIf="collateralValidatedPoolList.length > 0">
  <table class="fm-cdx-table__static">
    <thead id="collateral-analyzer-table-head">
      <tr class="th_row">
        <th class="th_column">
          <div class="th-column-padding">PREFIX</div>
        </th>
        <th class="th_column">COLLATERAL POOL #</th>
        <th class="th_column th-column-padding">
          <div class="th-column-padding">CUSIP</div>
        </th>
        <th class="th_column th_column--is-numeric">
          <div class="wa-net-interest-rate-header-width">WA NET INTEREST RATE</div>
        </th>
        <th class="th_column th-column-padding">
          <div class="th-column-padding">ISSUER</div>
        </th>
        <th class="th_column th-column-padding">
          <div class="th-column-padding">ISSUE DATE</div>
        </th>
        <th class="th_column">MATURITY DATE</th>
        <th class="th_column th_column--is-numeric">
          <div class="collateral-issurance-contributing-upb-header-width">
            COLLATERAL ISSUANCE CONTRIBUTING UPB
          </div>
        </th>
        <th class="th_column th_column--is-numeric">
          <div class="collateral-current-contributing-upb-header-width">
            COLLATERAL CURRENT CONTRIBUTING UPB
          </div>
        </th>
        <th class="th_column th_column--is-numeric">
          <div class="wa-months-to-maturity-header-width">WA MONTHS TO MATURITY</div>
        </th>
        <th class="th_column th_column--is-numeric">
          <div class="wa-interest-rate-setttlement-header-width">
            WA INTEREST RATE AT SETTLEMENT
          </div>
        </th>
      </tr>
    </thead>

    <tbody id="collateral-analyzer-table-body">
      <tr
        class="td_row"
        *ngFor="
          let collateralPool of collateralValidatedPoolList;
          let i = index;
          trackBy: trackByIdentity
        "
      >
        <td class="td_cell">
          <span id="collateral-prefix">{{
            collateralPool?.prefix ? collateralPool?.prefix : ''
          }}</span>
        </td>
        <td class="td_cell collateral-poolNumber-width">
          <span id="collateral-pool-number">{{
            collateralPool?.collateralPoolNumber ? collateralPool?.collateralPoolNumber : ''
          }}</span>
        </td>
        <td class="td_cell">
          <span id="collateral-cusip">
            {{ collateralPool?.cusip ? collateralPool?.cusip : '' }}</span
          >
        </td>
        <td class="td_cell td_cell--is-numeric">
          <span id="collateral-coupon">{{ collateralPool?.coupon | number: '1.3-3' }}</span>
        </td>
        <td class="td_cell">
          <ng-container *ngIf="collateralPool?.issuer === 'FN'">
            <span id="collateral-issuer">Fannie Mae</span>
          </ng-container>
          <ng-container *ngIf="collateralPool?.issuer === 'FR'">
            <span id="collateral-issuer-fr">Freddie Mac</span>
          </ng-container>
        </td>
        <td class="td_cell">
          <span id="collateral-issueDate">{{
            collateralPool?.issueDate | date: 'MM/dd/yyyy'
          }}</span>
        </td>
        <td class="td_cell">
          <span id="collateral-maturityDate">{{
            collateralPool?.maturityDate | date: 'MM/yyyy'
          }}</span>
        </td>
        <td class="td_cell td_cell--is-numeric">
          <span id="collateral-upbAmount">{{
            collateralPool?.upbAmount | currency: 'USD' : 'symbol' : '1.2-2'
          }}</span>
        </td>
        <td class="td_cell td_cell--is-numeric">
          <span id="collateral-upbAmountWithFactor">{{
            collateralPool?.upbAmountWithFactor | currency: 'USD' : 'symbol' : '1.2-2'
          }}</span>
        </td>
        <td class="td_cell td_cell--is-numeric mbs-wam-term-width">
          <span id="collateral-mbsWamTerm">{{
            collateralPool?.mbsWamTerm ? collateralPool?.mbsWamTerm : ''
          }}</span>
        </td>
        <td class="td_cell td_cell--is-numeric">
          <span id="collateral-mbsWacRate">{{ collateralPool?.mbsWacRate | number: '1.3-3' }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
